"use client";
import { UpcomingEventsSkeleton } from "@/components/partials/upcoming-events/components/loader";
import { Skeleton } from "@/components/ui/skeleton";

export const HeroSkeleton = () => {
  return (
    <div className="container grid w-full grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-12">
      {/* Hero content skeleton */}
      <div className="flex items-center">
        <div className="flex w-full flex-col items-start gap-12">
          <div className="flex w-full max-w-[1068px] flex-col gap-6">
            {/* Main heading skeleton */}
            <Skeleton className="h-12 w-full rounded-md lg:h-24" />
            <Skeleton className="h-12 w-3/4 rounded-md lg:h-24" />

            {/* Subheading skeleton */}
            <Skeleton className="h-6 w-full rounded-md lg:h-12" />
            <Skeleton className="h-6 w-4/5 rounded-md lg:h-12" />
          </div>
          {/* Button skeleton */}
          <Skeleton className="h-14 w-full rounded-full lg:w-64" />
        </div>
      </div>
      <div className="hidden lg:block">
        {/* Right column - upcoming events skeleton */}
        <UpcomingEventsSkeleton />
      </div>
    </div>
  );
};
